import React from 'react'
import { Center, Label, SVG, TextBlock, TextBlockProps, VBoxProps } from '~/ui/components'
import { SVGName } from '~/ui/components/SVG'
import { createUseStyles, layout } from '~/ui/styling'

export interface Props extends Omit<TextBlockProps, 'children'> {
  title:   string | null
  detail?: string
  icon?:   SVGName

  padded?: boolean
  gap?:    VBoxProps['gap']
  flex?:   VBoxProps['flex']

  children?:   React.ReactNode
  classNames?: React.ClassNamesProp
}

export default function Empty(props: Props) {
  const {
    title,
    detail,
    icon,
    dim = true,
    gap = layout.padding.l,
    padded = true,
    flex,
    small,
    h1,
    h2,
    h3 = !small && !h1 && !h2,
    children,
    classNames,
    ...rest
  } = props

  const $ = useStyles()

  return (
    <Center classNames={[$.empty, {padded}, classNames]} gap={gap} flex={flex}>

      <Center gap={small ? layout.padding.inline.xs : layout.padding.inline.s}>
        <Center gap={layout.padding.inline.m}>
          {icon != null && (
            <SVG name={icon} size={small ? iconSize.small : iconSize.normal} dim={dim}/>
          )}
          <Label h1={h1} h2={h2} h3={h3} dim={dim} small={small} bold align='center'>
            {title}
          </Label>
        </Center>

        {detail && (
          <TextBlock small={!small} tiny={small} dim={dim} align='center' {...rest}>
            {detail}
          </TextBlock>
        )}
      </Center>

      {children && (
        <Center classNames={$.extra}>
          {children}
        </Center>
      )}
    </Center>
  )
}

export const iconSize = {
  small:  layout.icon.s,
  normal: layout.icon.m,
}

const useStyles = createUseStyles({
  empty: {
    '&.padded': {
      ...layout.responsiveProp({padding: layout.padding.xl}),
    },
  },

  extra: {
    ...layout.responsiveProp({marginTop: layout.padding.m}),
  },
})